module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/link-bba5d0.svg";